export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="text-lg font-heading font-bold text-background-50 mb-4">天美麻花星空影视</h3>
              <p className="text-sm text-background-400 leading-relaxed">
                天美麻花星空影视免费观看提供影视视频、91电影视频、麻豆影视在线观看，电影在线观看、电视剧免费、综艺节目，高清不缓冲，最新影视每日更新。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2">
                {[
                  { label: '精彩视频', href: '#media' },
                  { label: '影视专题', href: '#index' },
                  { label: '热门话题', href: '#topics' },
                  { label: '热播榜单', href: '#ranking' },
                  { label: '最新动态', href: '#updates' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">内容分类</h4>
              <ul className="space-y-2">
                {['电影在线观看', '电视剧免费', '综艺节目', '91电影视频', '麻豆影视'].map((cat) => (
                  <li key={cat}>
                    <span className="text-sm text-background-400">{cat}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500">优质影视内容合作平台</p>
              <div className="flex flex-wrap gap-3 mt-3">
                <span className="px-3 py-1.5 text-xs text-background-400 bg-background-800 rounded-md">即将入驻</span>
                <span className="px-3 py-1.5 text-xs text-background-400 bg-background-800 rounded-md">敬请期待</span>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 天美麻花星空影视免费观看. 仅供学习交流，内容源自公开网络资源.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500">高清免费</span>
              <span className="text-xs text-background-500">不缓冲</span>
              <span className="text-xs text-background-500">最新影视</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}